// extracted by css-extract-rspack-plugin
export default {"fossaSelect":"UqdOZ9hYyQpKEjbC","menuEnd":"_5F_vtfiPncPvoSY","loadError":"iZGtelV60kKSYA9f","smoothLeft":"S60K5Tq0HUVJ8Ota","smoothRight":"CdiW66mQtt48_UbO"};